import {
  SET_CAR_RESULTS,
  SELECT_CAR,
  ORDER_CAR_BY,
  ORDER_CAR_BY_REVERSE,
  FILTER_CAR_BY_TYPE,
  FILTER_CAR_BY_SEARCH_TYPE,
  FILTER_CAR_BY_DETAILS,
  CLEAR_CAR,
} from '../actions/car';

const initialState = {
  components: {},
};

const initialFilterProps = {
  reverse: false,
  orderBy: 'MinimumfarePerDay',
  filterByType: 'ALL',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CAR_RESULTS:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            searchResults: action.searchResults,
            filterListBySearchType: action.filterListBySearchType,
            //filterListByType: action.filterListByType,
            filterByDetails: action.filterByDetails,
            filterBySearchType: action.filterBySearchType,
            ...initialFilterProps,
          },
        },
      };
    case SELECT_CAR:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            selectedCar: action.selectedCar,
          },
        },
      };

    case CLEAR_CAR:
      return {
        ...state,
        components: {},
      };
    case ORDER_CAR_BY:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            orderBy: action.orderBy,
            reverse: false,
          },
        },
      };
    case ORDER_CAR_BY_REVERSE:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            reverse: action.reverse,
          },
        },
      };
    case FILTER_CAR_BY_TYPE:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterByType: action.filterByType,
          },
        },
      };
    case FILTER_CAR_BY_SEARCH_TYPE:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            orderBy: initialFilterProps.orderBy,
            reverse: initialFilterProps.reverse,
            filterByType: initialFilterProps.filterByType,
            //filterListByType: action.filterListByType,
            filterByDetails: action.filterByDetails,
            filterBySearchType: action.filterBySearchType,
          },
        },
      };
    case FILTER_CAR_BY_DETAILS:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterByDetails: action.filterByDetails,
          },
        },
      };
    default:
      return state;
  }
};
